<div class="change-password-container">
  <div class="left-side">
    <div class="content-wrapper">
      <div class="message">
        <h1>Change Password</h1>
      </div>
      <div class="image-wrap">
        <img src="assets/images/forgot-illustration.png" alt="Illustration of a user changing their password" class="welcome-image" />
      </div>
    </div>
  </div>

  <div class="right-side">
    <div class="change-password-form-wrapper">
      <div class="logo-wrapper">
        <img src="assets/images/upspl_log.png" alt="UPSPL Company Logo" class="logo" />
      </div>

      <div *ngIf="successMessage" class="success" role="alert" aria-live="polite">{{ successMessage }}</div>
      <div *ngIf="errorMessage" class="error" role="alert" aria-live="polite">{{ errorMessage }}</div>

      <div class="form-header">
        <p class="change-password-title">
          Please set a new password for your account. Make sure it's strong and easy to remember.
        </p>
      </div>

      <form class="change-password-form" (ngSubmit)="onSubmit()" [formGroup]="changePasswordForm">
        <div class="form-group">
          <label for="password" class="form-label">New Password</label>
          <div class="password-wrapper">
  <input
    [type]="showNewPassword ? 'text' : 'password'"
    id="password"
    formControlName="password"
    placeholder="New Password"
    class="form-control"
    autocomplete="new-password"
    [attr.aria-invalid]="changePasswordForm.get('password')?.invalid"
    [attr.aria-describedby]="'password-error'"
  />
  <i
    class="pi"
    [ngClass]="showNewPassword ? 'pi-eye' : 'pi-eye-slash'"
    (click)="toggleNewPassword()"
  ></i>
          </div>


          <div id="password-error" class="password-hint">
            <small>Password must be at least 8 characters, include uppercase, lowercase, number, and symbol.</small>
          </div>
          <div *ngIf="changePasswordForm.get('password')?.invalid && (changePasswordForm.get('password')?.dirty || changePasswordForm.get('password')?.touched)" class="error">
            <div *ngIf="changePasswordForm.get('password')?.errors?.['required']">Password is required.</div>
            <div *ngIf="changePasswordForm.get('password')?.errors?.['minlength']">Password must be at least 8 characters long.</div>
            <div *ngIf="changePasswordForm.get('password')?.errors?.['pattern']">Password must include uppercase, lowercase, number, and symbol.</div>
          </div>
        </div>

        <div class="form-group">
          <label for="confirmPassword" class="form-label">Confirm Password</label>
          <div class="password-wrapper">
  <input
    [type]="showConfirmPassword ? 'text' : 'password'"
    id="confirmPassword"
    formControlName="confirmPassword"
    placeholder="Confirm Password"
    class="form-control"
    autocomplete="new-password"
    [attr.aria-invalid]="changePasswordForm.get('confirmPassword')?.invalid"
    [attr.aria-describedby]="'confirm-error'"
  />
  <i
    class="pi"
    [ngClass]="showConfirmPassword ? 'pi-eye' : 'pi-eye-slash'"
    (click)="toggleConfirmPassword()"
  ></i>
          </div>

          <div id="confirm-error" *ngIf="changePasswordForm.get('confirmPassword')?.invalid && (changePasswordForm.get('confirmPassword')?.dirty || changePasswordForm.get('confirmPassword')?.touched)" class="error">
            <div *ngIf="changePasswordForm.get('confirmPassword')?.errors?.['required']">Confirmation is required.</div>
          </div>
          <div *ngIf="changePasswordForm.errors?.['notSame']" class="error" id="match-error">Passwords do not match.</div>
        </div>

        <button type="submit" class="btn btn-change" [disabled]="changePasswordForm.invalid || isLoading">
          {{ isLoading ? 'Changing...' : 'Continue' }}
        </button>
      </form>
    </div>
  </div>
</div>
